window.$ = window.jQuery;
import VanillaCalendar from "@uvarov.frontend/vanilla-calendar";

function menu(){
    "use strict";

    jQuery(".site-header .mobile-menu").click(function(e){
        e.preventDefault();
        jQuery("body").toggleClass('active-menu');
    });
}

function slider() {
    const cSlider = jQuery('.slider-list').slick({
        dots : true,
        infinite : true,
        speed : 300,
        fade: false,
        cssEase: 'linear',
        slidesToShow : 1,
        slidesToScroll : 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
    });
}

function documents(){
    "use strict";

    jQuery(".documents-item-inner .title").click(function(e){
        e.preventDefault();
        jQuery(this).parents('.documents-item-inner').toggleClass('active');
    });
}

function coachesFilter() {
    jQuery(document).on('change', '.coaches-search select', function() {
        if(jQuery(this).val()!='0'){
            jQuery('.coach-item').css('display','none');
            jQuery('.coach-item[data-sport="'+jQuery(this).val()+'"]').css('display','block');
        }else{
            jQuery('.coach-item').css('display','block');
        }
    });
    jQuery(document).on('click', '.coaches-search form button', function(e) {
        e.preventDefault();
        if(jQuery('.coaches-search input').val()){
            jQuery('.coach-item').css('display','none');
            jQuery('.coach-item[data-title*="'+jQuery('.coaches-search input').val().toLowerCase()+'"]').css('display','block');
        }else{
            jQuery('.coach-item').css('display','block');
        }
    });
}

function calendar() {
    // eslint-disable-next-line no-shadow
    const calendar = new VanillaCalendar('#calendar', calendar_options);
    calendar.init();
}

function prices(){
    "use strict";

    jQuery(".prices-buttons .button a").click(function(e){
        e.preventDefault();
        const this_href = jQuery(this).attr('href');
        jQuery(".prices-buttons .button a").removeClass("active");
        jQuery(this).addClass("active");
        jQuery(".prices-tables-item").removeClass("active");
        jQuery(this_href).addClass("active");
    });
}


jQuery(document).ready(function () {
    "use strict";

    menu();
    slider();
    documents();
    coachesFilter();
    prices();

    if (typeof calendar_options !== 'undefined') {
        calendar();
    }

    jQuery(window).scroll(function () {
        const header = jQuery('body');
        const scroll = jQuery(window).scrollTop();
        if (scroll >= 35) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    });

});
